import { Logger } from '../utils/loggerUtils'

export const callWithdrawalWebhook = async (transactionId, variant) => {
  const logger = new Logger.Builder()
    .setContext('Withdrawal')
    .enableSentryIntegration()
    .build()
  const url = 'https://n8n-bi.kgp-tools.com/webhook/withdrawal-survey'

  try {
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ transactionId, variant }),
    })
  } catch (error) {
    logger.error('Error calling webhook:', error)
  }
}
